<template>
    <router-link v-bind:class="{'nav-link hoverito':true,'activito':menu.activo}" :to="{name:menu.ruta}" v-on:click.native="actualizar_menu(menu)">
        <i :class="`${menu.icono} text-primary`"></i>
        <span class="nav-link-text">{{menu.texto}}</span>
    </router-link>
</template>
<script>
import { mapState,mapActions } from 'vuex';
export default {
    props:['menu'],
    methods:{
        ...mapActions(['actualizar_menu'])
    },
    computed:{
        
    }
}
</script>
<style>
.activito {
   background-color: #c6cfe6;
  color: #fff;
}
</style>
